import { getLocale } from "../runtime";

const sv_showall = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Visa alla ${inputs.value}`
};

const showall = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_showall(inputs)
	return "showAll";
};

export { showall as "showAll" };